import { render } from "./ConfirmOrderCard.vue?vue&type=template&id=3ae161f1&scoped=true"
import script from "./ConfirmOrderCard.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderCard.vue?vue&type=script&lang=js"

import "./ConfirmOrderCard.vue?vue&type=style&index=0&id=3ae161f1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae161f1"]])

export default __exports__